// extracted by mini-css-extract-plugin
export var backdropBlur = "_eh-0";
export var contentCard = "_eh-5";
export var frame = "_eh-2";
export var image = "_eh-4";
export var imagePane = "_eh-3";
export var modal = "_eh-1";